module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery-software-list-editor"
  }, [_c('v-select', {
    ref: "select",
    attrs: {
      "taggable": _vm.canCreate,
      "filterable": false,
      "closeOnSelect": false,
      "options": _vm.results,
      "placeholder": "Example"
    },
    on: {
      "search": _vm.search,
      "input": _vm.select
    },
    nativeOn: {
      "keyup": function($event) {
        _vm.handleEmptySearch($event)
      }
    }
  }, [_c('template', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v("\n      Search software...\n    ")])], 2), _vm._v(" "), _c('ul', {
    staticClass: "software-list"
  }, _vm._l((_vm.selected), function(software, index) {
    return _c('li', {
      staticClass: "software-wrapper"
    }, [_c('button', {
      staticClass: "clear-button delete-btn",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deselect(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _vm._v(" "), _c('gallery-software', {
      attrs: {
        "software": software
      }
    })], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0152d28a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/GallerySoftwareListEditor.vue
// module id = 1960
// module chunks = 2